import { render, staticRenderFns } from "./TCCollect.vue?vue&type=template&id=15ce08ab"
import script from "./TCCollect.vue?vue&type=script&lang=js"
export * from "./TCCollect.vue?vue&type=script&lang=js"
import style0 from "./TCCollect.vue?vue&type=style&index=0&id=15ce08ab&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports